var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('communication-form',{attrs:{"loading":_vm.loading,"contact":_vm.contact,"property":_vm.property,"communicationData":_vm.communication,"isCollection":_vm.isCollection,"formErrors":_vm.formErrors},on:{"communicationSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }